export default "__VITE_ASSET__DR7TSmVd__"